import React, { lazy } from 'react';
import { Route } from 'react-router';
import routes from '../routes';
import Authenticated from '../../components/auth/Authenticated';

const DonationListScreen = lazy(() => import('../../screens/Donation/List'));

const donationRoutes = [
    <Route
        exact
        key={routes.DONATION_LIST}
        path={routes.DONATION_LIST}
        render={() => (
            <Authenticated redirectTo={routes.USER_LIST}>
                <DonationListScreen />
            </Authenticated>
        )}
    />,
];

export default donationRoutes;
